import type { ReactNode } from "react"

import { BoardPanel } from "@/components/auth/board-panel"

/* A narrow centred form on the page, and the board beside it on desktop. */
export const AuthSplitLayout = ({ children }: { children: ReactNode }) => {
  return (
    <section className="bg-secondary_subtle grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="relative flex justify-center px-4 py-12 md:items-center md:px-8">
        <div className="flex w-full flex-col gap-8 sm:max-w-90">{children}</div>
      </div>
      <div className="relative hidden py-3 pr-3 lg:flex">
        <BoardPanel />
      </div>
    </section>
  )
}
